import checkIsReadOnly from '../../../utils/checkIsReadOnly'
import countryListData from '../../../utils/countryListData'
import dateUtils from '../../../utils/dateUtils'
import { getTravelType } from './getCostingText'
import isExpiredDate from './isExpiredDate'

const full_months = [
	'january',
	'february',
	'march',
	'april',
	'may',
	'june',
	'july',
	'august',
	'september',
	'october',
	'november',
	'december',
]

const short_months = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
]

/**
 * This function used to get the default value to the GCM
 * @param {*} userDetails
 * @param {*} itineraryInfo
 */
export default function getGCMDefaultData(itineraryInfo = {}) {
	let costingDetails = JSON.parse(localStorage.getItem('costingDetails')) || {
		costingConfiguration: {},
		email: null,
	}
	const locale = sessionStorage.getItem('locale')
	costingDetails = {
		...costingDetails,
		...costingDetails.costingConfiguration,
	}
	const {
		itinerary = {},
		costingConfiguration = {
			departureAirport: '',
			nationality: '',
			flightsBookedByUserAlready: false,
			arrivalAirport: '',
			hotelGuestRoomConfigurations: [
				{
					adultCount: 2,
					childAges: [],
				},
			],
		},
	} = itineraryInfo
	const { costed, preferredMonth } = itinerary
	const isReadOnly = checkIsReadOnly(itinerary)
	const getDataValue = (data = 'departureAirport') => {
		return !costed
			? costingDetails[data]
			: data === 'nights'
			? itinerary[data]
			: costingConfiguration[data]
	}
	const getDepartureDate = () => {
		if (itineraryInfo.costingConfiguration || !preferredMonth) {
			return !isReadOnly && !costed
				? costingDetails.departureDate
				: costingConfiguration && costed
				? costingConfiguration.departureDate
				: null
		} else {
			if (preferredMonth) {
				const selectedMonthNumber = full_months.indexOf(
					preferredMonth.toLowerCase(),
				)
				const dateBasedOnMonthThisYear = new Date(
					new Date().getFullYear(),
					selectedMonthNumber,
					28,
				)
				const dateBasedOnMonthNextYear = new Date(
					new Date().getFullYear() + 1,
					selectedMonthNumber,
					28,
				)
				let date
				const utils = dateUtils()
				if (
					utils.isBetween(
						dateBasedOnMonthThisYear,
						utils.addDay(new Date(), 1),
						utils.addMonth(new Date(), 9),
					)
				) {
					date = dateBasedOnMonthThisYear
				} else {
					date = dateBasedOnMonthNextYear
				}
				return `${date.getDate()}/${
					short_months[date.getMonth()]
				}/${date.getFullYear()}`
			}
			return null
		}
	}
	const costingInfo = getDataValue('hotelGuestRoomConfigurations') || [
		{ adultCount: 2, childAges: [] },
	]

	// storing dates in YYYY-MM-DD in localstorage produced some error while reading it
	// we need to convert it to other format
	// converting date from YYYY-MM-DD to DD/MMM/YYYY
	let depDate = getDepartureDate()
	if (depDate && depDate.indexOf('-') > 1) {
		const dateValues = depDate.split('-')
		let monthValue = dateValues[1]
		if (+monthValue) {
			monthValue = short_months[+monthValue - 1]
		}
		depDate = `${dateValues[2]}/${monthValue}/${dateValues[0]}`
	}
	const departureAirport = getDataValue('departureAirport')
	let currentNationality = countryListData.filter(
		data =>
			data.value ===
			(costingConfiguration.nationality || costingDetails.nationality || ''),
	)[0]
	const returnValues = {
		departureAirport: departureAirport,
		nationality: locale ? currentNationality : '',
		arrivalAirport: !costed
			? departureAirport
			: getDataValue('arrivalAirport') || getDataValue('departureAirport'),
		departureDate: !costed ? null : depDate || null,
		hotelGuestRoomConfigurations: costingInfo,
		nights: getDataValue('nights'),
		travelType: getTravelType(costingInfo),
		dateExpired: isExpiredDate(depDate),
		flightsBookedByUserAlready: (
			costingInfo || { flightsBookedByUserAlready: false }
		).flightsBookedByUserAlready,
		departureAirportText: getDataValue('departureAirportText'),
		arrivalAirportText: getDataValue('arrivalAirportText'),
		passenger_details: {},
	}
	return {
		...returnValues,
		isArrivingDifferent:
			returnValues.departureAirport !== returnValues.arrivalAirport,
	}
}
